import { create } from "jss";
import rtl from "jss-rtl";
import React from "react";
import { StylesProvider } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// Configure JSS
const jss = create();
jss.use(rtl());
const theme = createTheme({
  direction: "rtl",
});

function RTL(props) {
  if (!props.isRTL) return <>{props.children}</>;
  return (
    <>
      {props.isRTL && (
        <StylesProvider jss={jss}>
          <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
        </StylesProvider>
      )}
    </>
  );
}

export default RTL;
